import { render } from "./TeachersStudent.vue?vue&type=template&id=624e8886"
import script from "./TeachersStudent.vue?vue&type=script&lang=js"
export * from "./TeachersStudent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__